import { createRoute } from '@tanstack/react-router'

import { areaRoute } from '@/app/routes/area-layout'
import { lazyPage } from '@/lib/lazy-page'

export const EntityAiSettings = lazyPage(
  () => import('./features/ai-settings/entity-ai-settings.lazy'),
  'EntityAiSettings',
)

export const entityAiSettingsRoute = createRoute({
  getParentRoute: () => areaRoute('settings'),
  path: 'ai',
  component: EntityAiSettings,
  staticData: { title: 'AI settings' },
})
